import { Link } from 'react-router-dom';

const features = [
  {
    title: 'Product Discovery',
    desc: 'Access hundreds of curated product finds across 14 categories in one organized spreadsheet.',
    icon: 'ri-search-eye-line',
  },
  {
    title: 'Price Research',
    desc: 'Compare prices quickly and identify the best deals without manually searching each item.',
    icon: 'ri-money-dollar-circle-line',
  },
  {
    title: 'Category Filtering',
    desc: 'Filter by Shoes, Hoodies, Jackets, Accessories, and more to find exactly what you need.',
    icon: 'ri-filter-3-line',
  },
  {
    title: 'Buying Speed',
    desc: 'Direct links to product pages eliminate redundant searching and speed up your purchase flow.',
    icon: 'ri-flashlight-line',
  },
  {
    title: 'Product Comparison',
    desc: 'View multiple products side by side in a structured format for easier decision making.',
    icon: 'ri-scales-3-line',
  },
  {
    title: 'Beginner Friendly',
    desc: 'No experience needed. The spreadsheet is designed to be intuitive for first-time Basetao users.',
    icon: 'ri-user-smile-line',
  },
];

export default function WhyBasetaoSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs font-semibold text-accent-600 uppercase tracking-widest mb-3">Why Choose</p>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 mb-4">
            Why Use a Basetao Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Using a Basetao spreadsheet transforms how you discover and shop for products. Here is what makes it essential for smart shoppers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-6 md:p-7 bg-background-100 rounded-xl border border-background-200/70 hover:border-accent-200 transition-all duration-200"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100/80 text-accent-600 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feat.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/article/basetao-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-primary-600 hover:text-primary-700 rounded-lg border border-primary-200 hover:border-primary-300 transition-colors whitespace-nowrap cursor-pointer"
          >
            Learn More About Basetao Spreadsheet
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}